import React from 'react'
import TextInput from '../form/TextInput'
import FileInput from '../form/FileInput'
import { SketchPicker } from 'react-color';
import AppBlobCache from '../../AppBlobCache'



export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    }
  }

  onChangeItem()
  {
    this.props.onChangeItem && this.props.onChangeItem();
  }

  render()
  {
    var {
      item
    } = this.props;

    var t = this;

    return (
        <div>
          {/*          
          <p>
            <label>文字風格</label>
            <select value={this.props.item._attributes.style}
                    onChange={(e) => {
                      this.props.item._attributes.style = e.target.value;
                      this.forceUpdate();
                    }}>
              <option value={'narrative'}>{'旁白'}</option>
              <option value={'msg'}>{'對白'}</option>
              <option value={'bubble'}>{'bubble'}</option>
            </select>
          </p>
          */}

{
            this.props.item.type === 'Text' || this.props.item.type === 'Media' ? (
                <p>
                  <div class="card">
                  <h5 class="card-header">角色 <input type={`checkbox`}
                             checked={!!this.props.item.name.enabled}
                             onChange={(e) => {
                               this.props.item.name.enabled = e.target.checked;
                               this.forceUpdate();
                             }}/></h5>                    
                    {this.props.item.name.enabled===true ? (
                    <div class="card-body">
                      <p>
                        <label>角色名稱</label>
                        <input type={`text`}
                              value={this.props.item.name._text}
                              onChange={(e) => {
                                this.props.item.name._text = e.target.value;
                                this.forceUpdate();
                              }}/>                        
                      </p>

                      <p>
                        <label>文字顏色</label><br/><br/>
                        <SketchPicker
                        disableAlpha={true}   
                          presetColors={['#FFFFFF','#FF0000','#00FF00','#0000FF']}             
                              color={item.name._attributes.color}
                              onChangeComplete={function(color,e){
                                item.name._attributes.color = color.hex;
                                t.forceUpdate();
                              }}            
                          />      
                      </p>

                      <p>
                        <label>文字大小</label>
                        <select value={this.props.item.name._attributes.size}
                                onChange={(e) => {
                                  this.props.item.name._attributes.size = e.target.value;
                                  this.forceUpdate();
                                }}>
                          <option value={'small'}>{'小'}</option>
                          <option value={'medium'}>{'中'}</option>
                          <option value={'large'}>{'大'}</option>
                          <option value={'xlarge'}>{'特大'}</option>
                        </select>
                      </p>

                      <p>
                        <label>字體粗細</label>
                        <select value={this.props.item.name._attributes.style}
                                onChange={(e) => {
                                  this.props.item.name._attributes.style = e.target.value;
                                  this.forceUpdate();
                                }}>
                          <option value={'regular'}>{'正常'}</option>
                          <option value={'bold'}>{'粗體'}</option>
                          <option value={'light'}>{'幼體'}</option>
                        </select>
                      </p>
                    </div>
                    ):null}
                  </div>
                </p>
            ) : null

          }

          {
            this.props.item.type === 'Text' || this.props.item.type === 'Media' ? (
              <p>
                <div class="card">
                  <h5 class="card-header">對話框</h5>                                        
                    <div class="card-body">
                      <p>
                        <label>對話框顏色</label><br/><br/>
                        <SketchPicker                   
                            disableAlpha={true}
                            presetColors={['#666666','#FFFFFF','#f8f2c6', '#ddf8c6', '#ffc1c5', '#c6f0f8']}             
                            color={this.props.item._attributes.itemColor}
                            onChangeComplete={function(color,e){
                              item._attributes.itemColor = color.hex;
                              t.forceUpdate();
                            }}            
                        />
                      </p>                      
                      </div>
                </div>
              </p>
            ):null
          }
          
          
          {
            this.props.item.type === 'Text' || this.props.item.type === 'Narrative' ? (
                <p>
                  <div class="card">
                    <h5 class="card-header">內文</h5>                                        
                    <div class="card-body">
                      <p>
                        <label>內文</label><br/>
                        <textarea
                              value={this.props.item.text._text}
                              onChange={(e) => {
                                this.props.item.text._text = e.target.value;
                                this.forceUpdate();
                              }}/>
                      </p>


                      <p>
                        <label>內文顏色</label><br/><br/>
                        <SketchPicker   
                            disableAlpha={true}             
                            color={this.props.item.text._attributes.color}
                            presetColors={["#000000","#FFFFFF",'#666666', '#FF0000']}
                            onChangeComplete={function(color,e){
                              item.text._attributes.color = color.hex;
                              t.forceUpdate();
                            }}            
                        />
                      </p>

                      <p>
                        <label>內文大小</label>
                        <select value={this.props.item.text._attributes.size}
                                onChange={(e) => {
                                  this.props.item.text._attributes.size = e.target.value;
                                  this.forceUpdate();
                                }}>
                          <option value={'small'}>{'小'}</option>
                          <option value={'medium'}>{'中'}</option>
                          <option value={'large'}>{'大'}</option>
                          <option value={'xlarge'}>{'特大'}</option>
                        </select>
                      </p>

                      <p>
                        <label>內文粗細</label>
                        <select value={this.props.item.text._attributes.style}
                                onChange={(e) => {
                                  this.props.item.text._attributes.style = e.target.value;
                                  this.forceUpdate();
                                }}>
                          <option value={'regular'}>{'正常'}</option>
                          <option value={'bold'}>{'粗體'}</option>
                          <option value={'light'}>{'幼體'}</option>
                        </select>
                      </p>
                    </div>
                  </div>
                </p>
            ) : null

          }

          {this.props.item.type === 'Media' ? (
                <p>
                  <fieldset>                                                          
                    <p>
                      <label>挑選JPG 圖檔</label>
                      <FileInput value={this.props.item.media._attributes.src}
                                  file_type={'image'}
                                  file_ext={'jpg'}
                                  onChange={(e, value, blob_url,base64_raw,file_ext) => {
                                    this.props.item.media._attributes.src = value;
                                    this.props.item.media._attributes.secondarySrc = value;
                                    this.props.item.media._attributes.base64_data = base64_raw;                                    
                                    this.props.item.media._attributes.file_ext = file_ext;                                    
                                    this.forceUpdate();
                                  }}/>
                    </p>                                          
                  </fieldset>
                </p>
            ) : null
          }

          


          {
            this.props.item.type === 'Text' || this.props.item.type === 'Narrative'  ? (
                <p>
                  <div class="card">
                  <h5 class="card-header">背景 <input type={`checkbox`}                                        
                             checked={!!this.props.item.bg.enabled}
                             onChange={(e) => {
                               this.props.item.bg.enabled = e.target.checked;
                               this.forceUpdate();
                             }}/>
                  </h5>
                    {this.props.item.bg.enabled===true ? (
                    <div class="card-body">

                        <p>
                        <label>插入背景</label>
                        <select value={this.props.item.bg._attributes.type}
                                onChange={(e) => {
                                  this.props.item.bg._attributes.type = e.target.value;
                                  delete item.bg._attributes.color;
                                  this.forceUpdate();
                                }}>
                          <option value={''}>{'請選擇格式'}</option>
                          <option value={'color'}>{'顏色'}</option>
                          <option value={'image'}>{'jpg 圖檔'}</option>
                          <option value={'video'}>{'mp4 影片'}</option>
                        </select>
                      </p>
                      {
                        this.props.item.bg._attributes.type === 'color' ? (
                      <p>
                        <label>顏色</label> <br/><br/>                       
                        <SketchPicker 
                        disableAlpha={true}  
                          presetColors={['#000000','#FFFFFF','#FF0000','#00FF00','#0000FF']}             
                              color={item.bg._attributes.color}
                              onChangeComplete={function(color,e){
                                item.bg._attributes.color = color.hex;
                                t.forceUpdate();
                              }}            
                          />
                      </p>
                        ) : null
                      }                    
                      {
                        this.props.item.bg._attributes.type === 'image' ? (
                            <p>
                              <label>上傳圖檔</label>
                              <FileInput value={this.props.item.bg._attributes.src}
                                        file_type={'image'}
                                        file_ext={'jpg'}
                                        onChange={(e, value, blob_url, base64_raw,file_ext) => {
                                          this.props.item.bg._attributes.src = value;
                                          this.props.item.bg._attributes.base64_data = base64_raw;
                                          this.props.item.bg._attributes.file_ext = file_ext;
                                          this.forceUpdate();
                                        }}/>
                            </p>
                        ) : null
                      }
                      {
                        this.props.item.bg._attributes.type === 'video' ? (
                            <p>
                              <label>上傳影片</label>
                              <FileInput value={this.props.item.bg._attributes.src}
                                        file_type={'video'}
                                        file_ext={'mp4'}
                                        onChange={(e, value, blob_url,base64_raw,file_ext) => {
                                          this.props.item.bg._attributes.src = value;
                                          this.props.item.bg._attributes.base64_data = base64_raw;
                                          this.props.item.bg._attributes.file_ext = file_ext;
                                          this.forceUpdate();
                                        }}/>
                            </p>
                        ) : null
                      }
                    </div>):null}
                  </div>
                </p>
            ) : null

          }





          {/* disable for now
            this.props.item.type === 'Text' ? (
                <p>
                  <fieldset>
                    <legend>Overlay</legend>
                    <p>
                      <label>Enabled</label>
                      <input type={`checkbox`}
                             checked={!!this.props.item.overlay.enabled}
                             onChange={(e) => {
                               this.props.item.overlay.enabled = e.target.checked;
                               this.forceUpdate();
                             }}/>
                    </p>

                    <p>
                      <label>Media Enabled</label>
                      <input type={`checkbox`}
                             checked={!!this.props.item.overlay.media.enabled}
                             onChange={(e) => {
                               this.props.item.overlay.media.enabled = e.target.checked;
                               this.forceUpdate();
                             }}/>
                    </p>

                    <p>
                      <label>type</label>
                      <select value={this.props.item.overlay.media._attributes.type}
                              onChange={(e) => {
                                this.props.item.overlay.media._attributes.type = e.target.value;
                                this.forceUpdate();
                              }}>
                        <option value={''}>{''}</option>
                        <option value={'image'}>{'image'}</option>
                        <option value={'video'}>{'video'}</option>
                      </select>
                    </p>


                    {
                      this.props.item.overlay.media._attributes.type === 'image' ? (
                          <p>
                            <label>Image Src</label>
                            <FileInput value={this.props.item.overlay.media._attributes.src}
                                       file_type={'image'}
                                       file_ext={'jpg'}
                                       onChange={(e, value, blob_url) => {
                                         this.props.item.overlay.media._attributes.src = value;
                                         this.forceUpdate();
                                       }}/>
                          </p>
                      ) : null
                    }
                    {
                      this.props.item.overlay.media._attributes.type === 'video' ? (
                          <p>
                            <label>Video Src</label>
                            <FileInput value={this.props.item.overlay.media._attributes.src}
                                       file_type={'video'}
                                       file_ext={'mp4'}
                                       onChange={(e, value, blob_url) => {
                                         this.props.item.overlay.media._attributes.src = value;
                                         this.forceUpdate();
                                       }}/>
                          </p>
                      ) : null
                    }
                  </fieldset>
                </p>
            ) : null

          }




          {
            this.props.item.type === 'Text' ? (
                <p>
                  <fieldset>
                    <legend>Sound</legend>
                    <p>
                      <label>Enabled</label>
                      <input type={`checkbox`}
                             checked={!!this.props.item.sound.enabled}
                             onChange={(e) => {
                               this.props.item.sound.enabled = e.target.checked;
                               this.forceUpdate();
                             }}/>
                    </p>
                    <p>
                      <label>Loop</label>
                      <input type={`text`}
                             value={this.props.item.sound._attributes.loop}
                             onChange={(e) => {
                               this.props.item.sound._attributes.loop = e.target.value;
                               this.forceUpdate();
                             }}/>
                    </p>
                    <p>
                      <label>Src</label>
                      <FileInput value={this.props.item.sound._attributes.src}
                                 file_type={'sound'}
                                 file_ext={'mp3'}
                                 onChange={(e, value, blob_url) => {
                                   this.props.item.sound._attributes.src = value;
                                   this.forceUpdate();
                                 }}/>
                    </p>
                  </fieldset>
                </p>
            ) : null
            */                                 
          }


        </div>
    )
  }
}